/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_c50ea6f9 .ms-Suggestions-itemButton{padding:0;border:none}.callout_c50ea6f9 .ms-Suggestions{min-width:300px}"}]);
export const callout = "callout_c50ea6f9";